import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { OrderComponent } from './order.component';
import { OrderListComponent } from './order-list/order-list.component';
import { Step1Component } from './wizards/step1/step1.component';
import { Step2Component } from './wizards/step2/step2.component';
import { Step3Component } from './wizards/step3/step3.component';
import { ClaimConfirmationComponent } from './claim-confirmation/claim-confirmation.component';
import { OfferConfirmationFormComponent } from './offer-confirmation-form/offer-confirmation-form.component';
import { OfferFormComponent } from './offer-form/offer-form.component';


const routes: Routes = [
	//{ path: '', redirectTo: '/test/menu', pathMatch: 'full' },
	{
		path: '',
		component: OrderComponent,
		children: [
			{ path: '', redirectTo: '/step1', pathMatch: 'full' },
			{
				path: 'list',
				component: OrderListComponent,
				data: { preload: true },

			},
			{
				path: 'step1',
				component: Step1Component

			},
			{
				path: 'step2/:id',
				component: Step2Component
			},
			{
				path: 'step3/:id',
				component: Step3Component
			},
			{
				path: 'offerConfirmationForm',
				component: OfferConfirmationFormComponent
			},
			{
				path: 'offerForm/:bidId',
				component: OfferFormComponent
			},
			// {
			//  path: 'approve',
			//  component: ClaimConfirmationComponent
			//},
			{
				path: 'approve/:tabId',
				component: ClaimConfirmationComponent
			}



		]

	}

];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forChild(routes),
		CommonModule,

	],

	//RouterModule export edilmez ise [ERROR ->]<router-outlet></router-outlet> hatasini verir.
	//Masterpage kullanimi icin gereklidir.
	exports: [RouterModule],


})
export class OrderRoutingModule { }
